export const LogoMark = ({ className = "w-10 h-12", gold = "#C5A059" }) => (
  <svg viewBox="0 0 100 120" fill="none" className={className} aria-hidden="true">
    <path
      d="M50 4 L90 19 V58 C90 87 73 106 50 116 C27 106 10 87 10 58 V19 Z"
      fill="currentColor"
      stroke={gold}
      strokeWidth="3"
    />
    <path
      d="M50 13 L82 25.5 V57 C82 82 68.5 98.5 50 107.5 C31.5 98.5 18 82 18 57 V25.5 Z"
      stroke={gold}
      strokeWidth="1"
      opacity="0.55"
    />
    <polygon
      points="50,32 52.8,40.1 61.4,40.3 54.6,45.5 57.1,53.7 50,48.8 42.9,53.7 45.4,45.5 38.6,40.3 47.2,40.1"
      fill={gold}
    />
    <path
      d="M35 62 V74 H50 M50 62 V84 M65 62 V74 H50"
      stroke={gold}
      strokeWidth="1.6"
      opacity="0.85"
    />
    <circle cx="35" cy="74" r="2" fill={gold} />
    <circle cx="65" cy="74" r="2" fill={gold} />
    <circle cx="50" cy="84" r="2" fill={gold} />
    <path d="M28 90 L72 90" stroke={gold} strokeWidth="1" opacity="0.5" />
  </svg>
);

export const LogoLockup = ({ dark = true, compact = false }) => (
  <div className="flex items-center gap-3" data-testid="logo-lockup">
    <LogoMark className="w-9 h-11 text-navy-900" />
    <div className="leading-none">
      <div className={`font-serif font-bold tracking-[0.08em] ${compact ? "text-base" : "text-lg"} ${dark ? "text-white" : "text-navy-900"}`}>
        UNITED STATES
      </div>
      <div className={`font-mono text-[9px] tracking-[0.24em] mt-1 ${dark ? "text-gold-400" : "text-gold-600"}`}>
        FEDERAL AGENCIES
      </div>
    </div>
  </div>
);
